import Icon from '@f/elements/Icon'

export const SocialList = () => {
  return (
    <div className='[ f-p-v-010 ] HLP-header-USPs'>
      <SocialListItem icon='check-circle-16px' text='100% kostenfrei' />
      <SocialListItem icon='check-circle-16px' text='Geprüfte Anbieter' />
      <SocialListItem icon='check-circle-16px' text='Mehr als 2500 Häuser' />
    </div>
  )
}

const SocialListItem = (props: { icon: string; text: string }) => {
  return (
    <li className='[ f-d-inbl f-hidden:xs f-m-r-020:m ] HLP-header-USP'>
      <Icon icon={props.icon} className='[ f-icon-040 f-c-st-sec f-m-r-010 ]' />
      <span className='[ f-d-inbl f-p-v-010 ]'>{props.text}</span>
    </li>
  )
}
